import WhereToBuyPC from '@/components/WTB';
import WhereToBuyH5 from '@/componentsH5/WTB';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';

export default function WhereToBuy({ SEO }: any) {
    const { isMobile, useLang, useRouter, useEffect } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    const { t } = useLang('wheretobuy');
    const LayoutCom = isMobile ? WhereToBuyH5 : WhereToBuyPC;
    const WHITE_SITE = ['us', 'au', 'cn', 'jp', 'ca', 'de', 'it', 'es', 'fr', 'eu', 'uk', 'sa', 'br', 'mx', 'ph'];

    useEffect(() => {
        if (!WHITE_SITE.includes(locale)) {
            return router.push('/404');
        }
    }, []);

    return (
        <PageLayout theme="white">
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={locale} list={WHITE_SITE} pathname={'where-to-buy'} />
            <LayoutCom />
        </PageLayout>
    );
}
